import { FINISHED } from "values/values";

export function needsEdge(edge_type: string): boolean{
    if(edge_type !== FINISHED){
        return true;
    }
    return false;
}